import React from "react"
import Dialog from "material-ui/Dialog"
import { FlatButton, TextField } from "material-ui"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import { IPosition, IPositionWorkInstructions } from "../../models"
import _ from "lodash"

interface IProps {
    handleClose(): void
    handleAdd(name: string, description: string): void
    //handleEdit(id: string, unit: IBudgetUnitItem, budgetedNumber: number, demandUnits: number, shiftTemplate: IScheduleShift): void
    positionWorkInstructions?: IPositionWorkInstructions
}

interface IState {
    openConfirmDialog: boolean
    name: string
    description: string
}

export default class WorkInstructionItemAddDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)

        this.state = {
            openConfirmDialog: false,
            name: "",
            description: "",
        }

        autobind(this)
    }

    render() {
        return (
            <Dialog
                open
                autoScrollBodyContent
                title={(!this.props.positionWorkInstructions ? "Add Work Instruction Item by Position" : "Edit Work Instruction Item by " + this.props.positionWorkInstructions.PositionName)}
                actions={[
                    <FlatButton
                        data-intercom-target={"AgreementTextDialog-Btn-CloseDialog"}
                        label={strings.CANCEL}
                        secondary
                        onTouchTap={() => { this.props.handleClose() }}
                    />,
                    <FlatButton
                        data-intercom-target={"AgreementTextDialog-Btn-CreateAgreementText"}
                        label={this.props.positionWorkInstructions ? strings.Save : strings.Add}
                        primary
                        onTouchTap={() => {
                            if (this.props.positionWorkInstructions) {
                                //this.props.handleEdit(this.props.positionBudgetItem.Id, this.state.unit, this.state.demandUnits, this.state.budgetedNumber, this.state.shiftTemplate)
                            } else {
                                this.props.handleAdd(this.state.name, this.state.description)
                            }
                        }}
                    />
                ]}
            >
                <div style={{ display: "grid", alignItems: "baseline" }}>
                    <div style={{displayRow: 1}}>
                        <TextField
                            style={{ width: "80%" }}
                            floatingLabelText={strings.Item + " " + strings.Name}
                            value={this.state.name}
                            onChange={e => this.setState({ name: e.target.value })}
                        />    
                    </div>
                    <div style={{displayRow: 1}}>
                        <TextField
                            style={{ width: "80%" }}
                            floatingLabelText={strings.Description}
                            value={this.state.description}
                            multiLine
                            fullWidth
                            rows={2}
                            rowsMax={2}
                            onChange={e => this.setState({ description: e.target.value })}
                        />    
                    </div>                    
                </div>
            </Dialog>
        )
    }
}
